/* eslint-disable
  camelcase
 */
import React from 'react';
import uuid from 'uuid/v4';

import { makeContextCacher } from 'common/utils/context';
import signatureContext from './context';
import hsFetch from 'hellospa/hs-fetch';

import CONSTANTS from './constants';

type SavedSignatures = {
  [key: string]: string,
}

type OnSignatureDataType = {
  type_code: string,
  create_type_code: string,
  signature: {
    image: string,
    text: string,
    font_family: string,
  },
};

const SignatureProviderIntercept = (props: any) => {
  const context = React.useContext<any>(signatureContext);

  const contextCache = makeContextCacher();
  const [selectedTab, setSelectedTab] = React.useState(CONSTANTS.TAB_DRAW);
  const [savedSignatures, setSavedSignatures] = React.useState<SavedSignatures>({});
  const savedInitials: string[] = [];

  const onSavedSignatureRemove = () => {};
  const onUploadSignature = () => {};
  const clearUploadedSignature = () => {};

  const onTabSelect = (tab: string) => setSelectedTab(tab);

  /**
   * Fetches data URI for typed-in signatures without saving to DB,
   * or returns the locally-generated data URI.
   */
  const upload = async (sigData: OnSignatureDataType, csrfToken: string) => {
    if (sigData.create_type_code === CONSTANTS.SIGNATURE_TYPE_CANVAS) {
      return { image: sigData.signature.image };
    }

    const data = {
      csrf_token: csrfToken,
      text: sigData.signature.text,
      font_family: sigData.signature.font_family,
    };

    try {
      const response = await hsFetch('/signature/generate', {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        method: 'POST',
        body: JSON.stringify(data),
      });
      if (response.ok) {
        return response.json();
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  const onSignatureData = (data: OnSignatureDataType) => {
    // @ts-ignore
    return upload(data, context.csrfToken)
      .then((obj: { image: string }) => {
        const guid = uuid();

        setSavedSignatures({
          ...savedSignatures,
          [guid]: obj.image,
        });

        return {
          signature_guid: guid,
        };
      });
  };

  const getSignatureUrl = (field: { guid: string }) => {
    return savedSignatures[field.guid]
      ? savedSignatures[field.guid]
      : context.getSignatureUrl(field);
  };

  const enabledTabs = [
    CONSTANTS.TAB_DRAW,
    CONSTANTS.TAB_TYPE,
    CONSTANTS.TAB_ERROR,
  ];

  const value = contextCache({
    ...context,
    savedSignatures,
    savedInitials,
    canInsertEverywhere: false,
    onSavedSignatureRemove,
    onUploadSignature,
    clearUploadedSignature,
    onSignatureData,
    getSignatureUrl,
    upload,
    onTabSelect,
    selectedTab,
    enabledTabs,
  });

  return (
    <signatureContext.Provider
      // @ts-ignore
      value={value}
    >
      {props.children}
    </signatureContext.Provider>
  );
};

export default SignatureProviderIntercept;
